import colors from '@lmc/common/constants'
import { GoalStatus } from '@lmc/ts-common'
import dayjs from 'dayjs'

const useGoalDueDate = (dueDate: string, status: GoalStatus) => {
  let formattedDueDate = ''
  let textColor = colors.black
  let icon: 'inTime' | 'overdue' | undefined

  if (status === GoalStatus.inProgress && dueDate) {
    const now = dayjs(new Date()).startOf('day')
    const due = dayjs(new Date(dueDate)).startOf('day')
    const differenceInDays = Math.abs(now.diff(due, 'days'))

    if (dayjs(due).isBefore(now)) {
      formattedDueDate = `Overdue +${differenceInDays} day${
        differenceInDays > 0 ? 's' : ''
      }`
      textColor = colors.red
      icon = 'overdue'
    } else if (differenceInDays === 0) {
      formattedDueDate = 'Due Today'
      icon = 'inTime'
    } else if (differenceInDays === 1) {
      formattedDueDate = 'Due Tomorrow'
      icon = 'inTime'
    } else if (differenceInDays <= 7) {
      formattedDueDate = 'Due this week'
      icon = 'inTime'
    }
  }

  return { formattedDueDate, textColor, icon }
}

export default useGoalDueDate
